import type {ReactElement} from 'react';
import {setComponentStyleProperty} from '@FormMakerReact/lib/form-maker-style-library';
import {useComponentStyleProperty} from '@FormMakerReact/lib/form-maker-style-hooks';
import {Text, TextSize} from '@Components/text/text';
import type {PresetButtonRenderArgs, StylePresetOption, StylePresetSelectorControlProps} from './style-preset-selector-control.types';
import styles from './style-preset-selector-control.module.scss';

export function StylePresetSelectorControl({component, property, labelKey, presets}: StylePresetSelectorControlProps): ReactElement {
  const current = useComponentStyleProperty(component, property);
  return (
    <div className={styles.body}>
      <Text val={window.i18next.t(labelKey)} size={TextSize.MD} className={styles.label} />
      <div className={styles.buttons}>
        {presets.map((preset) =>
          renderPresetButton({
            preset,
            isActive: isPresetActive(current, preset),
            onSelect: (): void => {
              setComponentStyleProperty(component, property, formatPresetValue(preset));
            },
          })
        )}
      </div>
    </div>
  );
}

function isPresetActive(currentCssValue: string, preset: StylePresetOption): boolean {
  return currentCssValue === formatPresetValue(preset);
}

function formatPresetValue(preset: StylePresetOption): string {
  return `${preset.value}${preset.unit}`;
}

function renderPresetButton({preset, isActive, onSelect}: PresetButtonRenderArgs): ReactElement {
  return (
    <button
      key={preset.id}
      type="button"
      aria-pressed={isActive}
      className={`${styles.button} ${isActive ? styles.active : ''}`}
      onClick={onSelect}
      // SVGs are pre-vetted constants with no user data — dangerouslySetInnerHTML is safe.
      dangerouslySetInnerHTML={{__html: preset.iconSvg}}
    />
  );
}
